import React from 'react'
import "../styles/sections/ExploreFeed.scss"
import FeedCard from '../components/Explore/FeedCard';

import thumbnailImage from "../assets/images/thum.jpg"
import Logo from "../assets/logos/codemmit-logo.png"

const ExploreFeed = () => {
    const feedCards = [
        {
            thumbnail: thumbnailImage,
            channelLogo: Logo,
            title: "lorem jsndf n jnjk n njknjkn kjnk jnjkn jndj nd sdjsd jnjdsnf jdsnfjksdfnjk ksjdfn jsndf n jnjk n njknjkn kjnk jnjkn jndj nd sdjsd jnjdsnf j lkasjdfk k;lklsjdfn kvns vknsfvk jnsdvkjns kvnsdvsdjlkvn sdkjvn sdkfvn klsdfnv skdnfkl sdnfldn",
            postedOn: "01/05/2024",
            channelName: "CodeShip",
            channelId: "CodeShip1",
            likes: "1.2k",
            views: "86k",
            Downloads: "500"
        },
        {
            thumbnail: thumbnailImage,
            channelLogo: Logo,
            title: "lorem jsndf n jnjk n kjnk jnjkn jndj nd sdjsd jnjdsnf jdsnfjksdfnjk ksjdfn",
            postedOn: "01/05/2024",
            channelName: "CodeShip",
            channelId: "CodeShip2",
            likes: "1.2k",
            views: "5.9k",
            Downloads: "500"
        },
        {
            thumbnail: thumbnailImage,
            channelLogo: Logo,
            title: "lorem jsndf n jnjk n jnk jnjkn jndj nd sdjsd jnjdsnf jdsnfjksdfnjk ksjdfn",
            postedOn: "01/05/2024",
            channelName: "CodeShip",
            channelId: "CodeShip3",
            likes: "1.2k",
            views: "2k",
            Downloads: "500"
        },
        {
            thumbnail: thumbnailImage,
            channelLogo: Logo,
            title: "lorem jsndf n jnjk n jn jnjkn jndj nd sdjsd jnjds jdsnfjksdfnjk ksjdfn",
            postedOn: "01/05/2024",
            channelName: "CodeShip",
            channelId: "CodeShip4",
            likes: "1.2k",
            views: "56k",
            Downloads: "500"
        },
        {
            thumbnail: thumbnailImage,
            channelLogo: Logo,
            title: "lorem jsndf n jnjkjnk jnjkn jndj nd sdjsd jnjdsnf jdsnfjksdfnjk ksjdfn",
            postedOn: "01/05/2024",
            channelName: "CodeShip",
            channelId: "CodeShip5",
            likes: "1.2k",
            views: "5k",
            Downloads: "500"
        },
        {
            thumbnail: thumbnailImage,
            channelLogo: Logo,
            title: "lorem jsndf n jnjkjnk jnjkn jndj nd sdjsd jnjdsf jdsnfjksdfnjk ksjdfn",
            postedOn: "01/05/2024",
            channelName: "CodeShip",
            channelId: "CodeShip5",
            likes: "1.2k",
            views: "5k",
            Downloads: "500"
        },
        {
            thumbnail: thumbnailImage,
            channelLogo: Logo,
            title: "lorem jsndf n jnjkjnk jnjkn jndj nd sdjsd jndsnf jdsnfjksdfnjk ksjdfn",
            postedOn: "01/05/2024",
            channelName: "CodeShip",
            channelId: "CodeShip5",
            likes: "1.2k",
            views: "5k",
            Downloads: "500"
        },
        {
            thumbnail: thumbnailImage,
            channelLogo: Logo,
            title: "lorem jsndf n jnjkjnk jnjknjdsnf jdsnfjksdfnjk ksjdfn",
            postedOn: "01/05/2024",
            channelName: "CodeShip",
            channelId: "CodeShip5",
            likes: "1.2k",
            views: "5k",
            Downloads: "500"
        },
        {
            thumbnail: thumbnailImage,
            channelLogo: Logo,
            title: "lorem jsnjnjdsnf jdsnfjksdfnjk ksjdfn",
            postedOn: "01/05/2024",
            channelName: "CodeShip",
            channelId: "CodeShip5",
            likes: "1.2k",
            views: "5k",
            Downloads: "500"
        },
        {
            thumbnail: thumbnailImage,
            channelLogo: Logo,
            title: "lorem jsnjnjdsnf jdsnfjksdfnjk ksjdfn",
            postedOn: "01/05/2024",
            channelName: "CodeShip",
            channelId: "CodeShip5",
            likes: "1.2k",
            views: "5k",
            Downloads: "500"
        },
        {
            thumbnail: thumbnailImage,
            channelLogo: Logo,
            title: "lorem jsnjnjdsnf jdsnfjksdfnjk ksjdfn",
            postedOn: "01/05/2024",
            channelName: "CodeShip",
            channelId: "CodeShip5",
            likes: "1.2k",
            views: "5k",
            Downloads: "500"
        },
    ];

    return (
        <div className='explore-feed'>
            <FeedCard feedDetails={feedCards} />
        </div>
    )
}

export default ExploreFeed